import { FunctionalComponent, VNode, h } from '@stencil/core';
import { height, svgPathData, width } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';

import { generateSVGImage } from 'utils/imageHelper';

interface AdsTooltipTriggerProps {
  tooltipIsActive: boolean;
  describedById: string;
  label: string;
  toggleEventHandler: (evt: MouseEvent | KeyboardEvent) => void;
  openTooltipOnInteraction?: boolean;
}

export const AdsTooltipTrigger: FunctionalComponent<AdsTooltipTriggerProps> = ({
  tooltipIsActive,
  describedById,
  label,
  toggleEventHandler,
  openTooltipOnInteraction = false,
}) => {
  const classes = ['c-tooltip__trigger'];
  if (tooltipIsActive) {
    classes.push('is-active');
  }

  const attributes = {
    'aria-describedby': describedById,
    'aria-label': label,
    'aria-controls': describedById,
    role: 'tooltip',
    onMouseEnter: openTooltipOnInteraction ? toggleEventHandler : null,
    onMouseLeave: openTooltipOnInteraction ? toggleEventHandler : null,
    'data-track': 'true',
    'data-track-value': label,
    onkeydown: openTooltipOnInteraction ? toggleEventHandler : null,
    onkeyup: openTooltipOnInteraction ? toggleEventHandler : null,
  };

  return (
    <button class={classes.join(' ')} onClick={toggleEventHandler} {...attributes}>
      {generateSVGImage({ data: svgPathData, height, width })}
    </button>
  ) as VNode;
};
